var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-1 w-full no-overflow"},[_c('vs-pagination',{attrs:{"total":_vm.totalLenght},model:{value:(_vm.currentx),callback:function ($$v) {_vm.currentx=$$v},expression:"currentx"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }